import { formatAmount } from "@/D2C/features/auth/utils/utils";
import { App_Url_New } from "@/shared/common/static";
import { axiosInstance } from "@/shared/lib/axiosInstance";
import { showToast } from "@/shared/lib/toast";
import { openModal } from "@/shared/redux/reducers/uiSlice";
import { Download, Mail, Share2 } from "lucide-react";
import { useDispatch } from "react-redux";
import { usePosterReducers } from "../../redux/store/useGetData";
import { Button } from "../Button";
import CompareQuote from "./CompareQuote";

type CompareBarProps = {
  onBuyNow?: (quote: any) => Promise<void> | void;
  isReadOnly?: boolean;
};

export default function CompareBar({ onBuyNow, isReadOnly = false }: CompareBarProps) {
  const {
    commonSlice: { quoteList },
    travel,
    quoteFlow,
    ui: { name },
  } = usePosterReducers();
  const compareQuote = quoteList?.filter((quote) => quote.isCompare);
  console.log("compareQuotecompareQuote", compareQuote);
  const count = compareQuote?.length || 0;
  const dispatch = useDispatch();

  const handleMailAPI = async () => {
    console.log("Mail process started...");

    const savedTravel =
      quoteFlow.travelDetails ||
      (travel?.request
        ? {
            coverage: travel.request.travel_details?.coverage_type,
            fromCountry: travel.request.travel_details?.departure,
            destination: travel.request.travel_details?.destination,
            planType: travel.request.travel_details?.plan_type,
            startDate: travel.request.travel_details?.travel_dates?.start_date,
            endDate: travel.request.travel_details?.travel_dates?.end_date,
          }
        : {});

    const savedPersonal =
      quoteFlow.personalDetails ||
      (travel?.request
        ? {
            firstName: travel.request.personal_details?.first_name,
            lastName: travel.request.personal_details?.last_name,
            email: travel.request.personal_details?.email,
          }
        : {});

    const selectedQuotes = quoteList.filter((quote: any) => quote.isCompare === true);
    const toEmail = savedPersonal.email;
    const payload = {
      template_key: "QUOTE_EMAIL",
      email: toEmail,
      channels: [
        {
          type: "email",
          provider: "azure",
          enabled: true,
        },
      ],
      payload: {
        customer_name:
          `${savedPersonal.firstName || ""} ${savedPersonal.lastName || ""}`.trim() || "John Doe",

        trip_details: {
          destination: savedTravel.destination || "Dubai",
          start_date: savedTravel.startDate?.replace(/\./g, "-") || "2026-03-01",
          end_date: savedTravel.endDate?.replace(/\./g, "-") || "2026-03-10",
        },

        quotes: selectedQuotes.map((q: any) => {
          const priceObj = q.plan?.price || q.price || {};

          return {
            insurer: {
              name: q.insurer?.name || "N/A",
              insurer_id: q.insurer?.insurer_id || 0,
              insurer_sequence: q.insurer?.insurer_sequence || 0,
            },
            plan: {
              name: q.plan?.name || "Standard",
              id: q.plan?.id || 0,
              price: {
                amount: priceObj.amount || 0,
                currency: priceObj.currency || "AED",
                vat: priceObj.vat || 0,
                amount_with_vat: formatAmount(priceObj.amount_with_vat),
              },
            },
            sections: q.sections || [],
            isCompare: q.isCompare,
          };
        }),
      },
    };
    console.log("FINAL DYNAMIC PAYLOAD:", payload);
    showToast(`Sending email to ${toEmail}...`, "success");
    try {
      const response = await axiosInstance.post(App_Url_New.ApiEndPoint.sendNotification, payload);
      showToast(`Email sent successfully! to ${toEmail}`, "success");
    } catch (error) {
      console.error("Mail API Error:", error);
      showToast("Failed to call API. Check Network tab.", "error");
    }
  };

  function additionalLogoList() {
    const logos = [
      { icon: Download, label: "Download" },
      { icon: Share2, label: "Share" },
      { icon: Mail, label: "Mail" },
    ];
    return (
      <div className="flex justify-center space-x-4 ">
        {logos.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              if (item.label === "Mail") {
                console.log("Mail icon clicked!");
                // CALL THE FUNCTION HERE:
                handleMailAPI();
              }
            }}
            className="p-2 cursor-pointer flex gap-2 items-center hover:bg-theme-surface-soft hover:rounded-[5px]"
          >
            <item.icon className="w-4 h-4" />
            <div className="text-xs text-theme-text-muted mt-1 text-center">{item.label}</div>
          </div>
        ))}
      </div>
    );
  }

  function onCompare() {
    dispatch(
      openModal({
        name: App_Url_New.PopupKeys.COMPARE_QUOTES,
        children: <CompareQuote onBuyNow={onBuyNow} isReadOnly={isReadOnly} />,
        className: "max-w-6xl w-full h-full",
        outerClassName: "items-center",
        title: "Compare Quotes",
        header: additionalLogoList(),
      })
    );
  }

  if (count === 0) return null;

  return (
    <>
      {/* <div className="h-20" /> */}
      {name == App_Url_New.PopupKeys.COMPARE_QUOTES ? (
        <></>
      ) : (
        <div className="fixed inset-x-0 bottom-0 z-60 border-t bg-theme-surface shadow-lg">
          <div className="mx-auto flex max-w-xs items-center justify-between px-4 py-3">
            <span className="text-sm text-theme-text-muted">
              <span className="font-semibold"> {count} </span> quote
              {count > 1 ? "s" : ""} selected
            </span>
            <Button
              className={`
  ${
    count < 2
      ? "cursor-not-allowed bg-theme-text-soft "
      : "bg-theme-primary hover:bg-theme-primary-hover"
  }`}
              disabled={count < 2}
              onClick={onCompare}
            >
              Compare Quotes
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
